<template lang="pug">
.tab.flex_v(:class="{ selected: selected }")
  h5 {{ title }}
  img(:src="img")
</template>

<script>
export default {
  name: "Tab",
  props: {
    title: String,
    img: String,
    selected: Boolean,
  },
  components: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/scrollable_tab_common";
</style>
